<template>
  <div id="Drivers">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex w-100 justify-content-between align-items-center">
          <h1 class="labelBold">
            {{ this.$t(`mobilityOnDemand.vehiclesMobility.title`) }}
          </h1>
         <div class="col-md-2">
      

          <router-link :to="{
        name: 'Vehicle New'
      }">
        <button class="btn btn-dark control publish-btn">{{$t('mobilityOnDemand.vehiclesMobility.addVehicle')}}</button>
      </router-link>
        </div>
      </div>
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="vehicleTable">

           <template #status="props">{{ translateStatus(props.row.status) }}</template>

          <template v-slot:actions="props">
            <div class="actionsDrivers">
              <!-- Edit -->
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Vehicle Edit',
                  params: {
                    idCar: props.row.id,
                    carplate: props.row.car_plate,
                    edit: true
                    // edit: props.row
                  }
                }"
              >
                <i class="far fa-edit"></i>
              </router-link>
            </div>
          </template>
            <div slot="filter__status">
              <select class="form-control" name="status" id ="status" v-model="selected"  @change="filterStatus(selected)">
              <option v-for="option in options"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{option.name }}
              </option>
            </select>
            </div>
        </v-server-table>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/MobilityOnDemand.js";
const api = new API_SERVICE();

export default {
  data() {
    return {
      selected:""
    };
  },
  methods: {

      translateStatus(status) {
      if (status == "available"){
      status = this.$t("mobilityOnDemand.driversMobility.active")
   
      }
      else if(status == "unavailable"){
       status = this.$t("mobilityOnDemand.driversMobility.inactive")
       
      }
     
       else {
        status
      }
        return status
    },

     filterStatus: function( $event)
    {
      
      if($event != "choose"){
      let status = ""
      if ($event == "available"){
    	status = "available"
	    }
      else if($event == "unavailable"){
    	status = "unavailable"
	    }
      this.vehicleTable.setFilter({"status":status});
      
      }
      else{
         
         this.vehicleTable.setFilter({"status":""});
     
      }
    },
    deleteDriver: async function(event) {
      console.log('computing ....', this.$refs.vehicleTable);
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.deleteDriver(event.row);
        this.$refs.vehicleTable.refresh();
        this.$store.commit("global/SET_LOADING", false);
        return resp;
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    downloadTable: async function(event) {
      const filterParams = this.$refs.vehicleTable.query;
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.downloadBusDriversTable(filterParams);
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      }
    }
  },
  computed: {

        options(){
        return[
                {id:"choose",name: this.$t('mobilityOnDemand.choose')} ,
                {id:"available",name: this.$t("mobilityOnDemand.vehiclesMobility.active")} ,
                {id:"unavailable",name: this.$t("mobilityOnDemand.vehiclesMobility.inactive")}
              ]},
     

    vehicleTable: function() {
      return this.$refs.vehicleTable;
    },
    table_columns: function() {
      return [
        "id",
        "model",
        "car_plate",
        "status",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `mobilityOnDemand.vehiclesMobility.tableVehicles.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page ;
            queries.limit = data.limit;
            queries.query = data.query;
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              const resp = await api.getAllVehicles(data);
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
               this.$store.commit("global/SET_ALERT", {
                 msg: `${error}`,
                 show: true,
                 type: "error"
               });
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.data,
              count: response.total
            };
          }
        }
      };
    }
  }
};
</script>

<style lang="scss">

.VueTables__status-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
 }
#status{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}

#Drivers {
  background-color: $white;
  padding: 2rem 4rem;
}
.btn-download {
  padding: 0.5rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.actionsDrivers {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actionsDrivers > *, button {
  cursor: pointer;
}
.actionsDrivers > .edit-btn {
  color: #000000;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: #000000;
  }
}

  .VueTables__table .actions-column {
    position: sticky;
    right: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      right: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .actions-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .actions-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
   .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }

</style>

<style>
.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown {
  float: left !important;
}
.VueTables__columns-dropdown > button {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
}
.VueTables .dropdown .dropdown-menu a {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VueTables .dropdown .dropdown-menu a > input {
  margin-right: 0.5rem;
}


</style>
